import PremiumPlayerInitializer from 'shared/initializers/premium_player_initializer';
import TelcoHeaderEnrichment from 'shared/initializers/telco_header_enrichment';
import { VidioHelpers } from 'shared/vidio_helpers';

export default class EmbedInteractionStatus {
  static init() {
    var href = VidioHelpers.page_url();

    if (this.isThroughHeProcess(window.disableHeProcess, href)) {
      this.processTelcoEnrichment();
    } else {
      this.getStatus(false);
    }
  }

  static processTelcoEnrichment(){
    TelcoHeaderEnrichment.process(function(){
      this.getStatus(true);
    }.bind(this));
  }

  static setupTelcoHeaderEnrichment() {
    return new TelcoHeaderEnrichment();
  }

  static isThroughHeProcess(disableHeProcess, url) {
    return (!disableHeProcess) && (url.indexOf('/embed') >= 0) && (url.indexOf('header_enrichment=true') >= 0);
  }

  static getStatus(bypass_varnish=false) {
    $.ajax({
      url: this.decideInteractionPath(bypass_varnish),
      dataType: "json",
      method: "GET"
    }).done(function(data) {
      this.onInteractionSuccess(data);
    }.bind(this));
  }

  static decideInteractionPath(bypass_varnish=false){
    if(bypass_varnish == true){
      return '/interactions.json?varnish_bypass=true';
    } else {
      return '/interactions.json';
    }
  }

  static onInteractionSuccess(data){
    window.currentUser = data.current_user;

    var user = Object.assign({}, data.user_he, data.current_user);

    this.setCsrfToken(data);

    this.setMeta(user);
    this.getShowStream(user);
  }

  static getShowStream(currentUser){
    let initializer = EmbedInteractionStatus.setupPremiumPlayerInitializer(currentUser);
    initializer.initialize();
  }

  static setupPremiumPlayerInitializer(currentUser){
    return (new PremiumPlayerInitializer(currentUser));
  }

  static setCsrfToken(data) {
    if(data.current_user.token !== undefined) {
      $('meta[name="csrf-token"]').attr("content", data.current_user.token);
    }
  }

  static setMeta(user){
    $('meta[name="current-user-name"]').attr('content',user.username);
    $('meta[name="current-user-id"]').attr('content',user.user_id);

    if(window.kmklabs){
      if(!window.kmklabs.gtm.user_name){
        window.kmklabs.gtm.user_name = user.username;
      }
      if(!window.kmklabs.gtm.user_id){
        window.kmklabs.gtm.user_id = user.user_id;
      }
    }
  }
}
